// @flow
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import TwitterWidgets from 'twitter-widgets';

export default class TweetTimeline extends Component {
  timeout = null;

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleButton(root: Object) {
    const node = findDOMNode(root);
    if (!node) {
      return;
    }
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      TwitterWidgets.load((twitter) => {
        twitter.widgets.createTimeline({
          sourceType: 'profile',
          screenName: 'artofspoonerism',
        }, node, {
          height: '700',
          related: 'spoonerismorg',
          tweetLimit: 3,
        });
        this.timeout = null;
      });
    }, 300);
  }

  render() {
    return (
      <div
        {...this.props}
        style={{minHeight: 465}}>
        <div ref={this.handleButton.bind(this)} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TweetTimeline.js
 **/